<ion-header>
  <ion-toolbar color="primary ion-text-center">
    <ion-title>
      <span>{{ 'SagaMobile.AssignementRequest.Title' | translate }}</span>
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="padding">
  <ion-card (click)="openMyCard()" *ngIf="unitActivity && unitActivity.callcard" #mapCard style="flex: 1">
    <ion-item #mapLabel>
      <ion-icon [style.color]="unitActivity.callcard.color.tinycolor.toRgbString()" name="pin" slot="start" large></ion-icon>
      <h2>{{ unitActivity.callcard.CreatedUTC | moment: 'LLLL' }}</h2>
      <p>{{ unitActivity.callcard.event.EventText }}</p>
      <p>{{ unitActivity.callcard.location.FormattedLocation }}</p>
    </ion-item>
  </ion-card>

  <ion-button *ngIf="canRefuse" expand="full" fill="clear" (click)="cancel()">
    <span>{{ 'SagaMobile.AssignementRequest.Buttons.Refuse' | translate }}</span>
  </ion-button>
  <ion-button expand="full" (click)="accept()" color="primary" style="height: 65px;">
    <span>{{ 'SagaMobile.AssignementRequest.Buttons.Accept' | translate }}</span>
  </ion-button>
</ion-content>
